import * as $ from 'jquery';
import * as log from 'loglevel';
import {game} from '../GameCore';
import {showPrimaryScreen, showSecondaryScreen} from '../../screens/ScreenManager';
import {registerUiSfx, playUiVoiceover} from "../../audio/voiceovers/VoiceOverManager";

var progressTimer: number;

/**
 * preload game assets
 */
export function preloadGameAssets ()
{
    //game.load.image('tile', 'assets/sprites/test-tile_64x64.png');
    //game.load.image('switch', 'assets/sprites/test-tile-switch_64x64.png');
    //game.load.image('zingy', 'assets/sprites/player.png');
    //game.load.image('sign', 'assets/sprites/sign.png');
    game.load.image('truck', 'assets/images/game/truck.png');
    game.load.image('zingy-look-around', 'assets/images/ui/zingy-look-around.gif');
    game.load.image('zingy-sad', 'assets/images/ui/zingy-sad.gif');
    game.load.image('zingy-celebrate', 'assets/images/ui/zingy-celebrate.gif');

    game.load.atlasJSONHash('zingy', 'assets/sprites/zingy/edf-zingy.png', 'assets/sprites/zingy/edf-zingy.json');
    game.load.atlasJSONHash('sprites', 'assets/sprites/sprites/edf-pp-sprites.png', 'assets/sprites/sprites/edf-pp-sprites.json');
    game.load.atlasJSONHash('lights', 'assets/sprites/sprites/edf-lights.png', 'assets/sprites/sprites/edf-lights.json');

    //  backgrounds

    //game.load.atlasJSONHash('bg-gym', 'assets/sprites/backgrounds/gym.png', 'assets/sprites/backgrounds/gym.json');
    //game.load.atlasJSONHash('bg-science', 'assets/sprites/backgrounds/science.png', 'assets/sprites/backgrounds/science.json');
    //game.load.atlasJSONHash('bg-outside', 'assets/sprites/backgrounds/outside.png', 'assets/sprites/backgrounds/outside.json');
    //game.load.atlasJSONHash('bg-music', 'assets/sprites/backgrounds/music.png', 'assets/sprites/backgrounds/music.json');
    //game.load.atlasJSONHash('bg-corridor', 'assets/sprites/backgrounds/corridor.png', 'assets/sprites/backgrounds/corridor.json');

    game.load.atlasJSONHash('bg-park', 'assets/sprites/backgrounds/park.jpg', 'assets/sprites/backgrounds/park.json');
    game.load.atlasJSONHash('bg-playground', 'assets/sprites/backgrounds/playground.jpg', 'assets/sprites/backgrounds/playground.json');
    game.load.atlasJSONHash('bg-street', 'assets/sprites/backgrounds/street.jpg', 'assets/sprites/backgrounds/street.json');
    game.load.atlasJSONHash('bg-track', 'assets/sprites/backgrounds/track.jpg', 'assets/sprites/backgrounds/track.json');
    //game.load.atlasJSONHash('bg-corridor', 'assets/sprites/backgrounds/corridor.png', 'assets/sprites/backgrounds/corridor.json');

    //  obstacles

    game.load.atlasJSONHash('obstacles', 'assets/sprites/obstacles/obstacles.png', 'assets/sprites/obstacles/obstacles.json');
    game.load.atlasJSONHash('recycling-pickups', 'assets/sprites/recycling-pickups/recycling-pickups.png', 'assets/sprites/recycling-pickups/recycling-pickups.json');

    game.load.onLoadComplete.add(onLoadComplete, this);

    //  particles

    game.load.atlasJSONHash('particles', 'assets/sprites/particles/particles.png', 'assets/sprites/particles/particles.json');

    //  audio

    game.load.audio('button-click', 'assets/audio/button-click.mp3');
    game.load.audio('jump', 'assets/audio/jump.mp3');
    game.load.audio('hit-head', 'assets/audio/hit-head.mp3');
    game.load.audio('hit-obstacle', 'assets/audio/hit-obstacle.mp3');
    game.load.audio('hit-recycling', 'assets/audio/hit-recycling.mp3');
    game.load.audio('level-complete', 'assets/audio/level-complete.mp3');
    game.load.audio('game-over', 'assets/audio/game-over.mp3');
    game.load.audio('bad-power-up', 'assets/audio/bad-power-up.mp3');
    game.load.audio('speed-up', 'assets/audio/speed-up.mp3');
    game.load.audio('points-up', 'assets/audio/points-up.mp3');
    game.load.audio('time-up', 'assets/audio/time-up.mp3');
    game.load.audio('correct-answer', 'assets/audio/correct-answer.mp3');
    game.load.audio('incorrect-answer', 'assets/audio/incorrect-answer.mp3');
    game.load.audio('incorrect-answer', 'assets/audio/incorrect-answer.mp3');
    game.load.audio('zingy-sign', 'assets/audio/zingy-sign.mp3');
    //game.load.audio('toggle-light-switch', 'assets/audio/toggle-light-switch.mp3');
    game.load.audio('recycling-pickup-collected', 'assets/audio/points-up.mp3');

    //  voiceovers

    game.load.audio('ui-sfx', 'assets/audio/voiceovers/ui-voiceovers-sprite.mp3');


    //  get the progress percentage

    progressTimer = setInterval(function()
    {
        document.getElementById('preloader-percentage').innerHTML = game.load.progress + '%';
    }, 200);


    let voTimer = setInterval(function()
    {
        if ( ! game.cache.isSoundDecoded('ui-sfx')) return;

        clearInterval(voTimer);

        setTimeout(() => playUiVoiceover('main-menu--recycling-adventure'), 500);

    }, 100);
}

//PreloadScene.prototype.preload = function ()
//{    //show percentage    t
//        this.progress = this.game.add.text(this.game.world.centerX, this.game.world.centerY-30, '0%', {fill: 'white'});
//        this.progress.anchor.setTo(.5,.5);        //show progress bar    var progressBar =
//      this.game.add.sprite(this.game.world.centerX, this.game.world.centerY, 'progressBar');
//      progressBar.anchor.setTo(0.5, 0.5);     this.game.load.setPreloadSprite(progressBar);
//      this.game.load.onFileComplete.add(this.fileComplete, this);    };PreloadScene.prototype.fileComplete = function
//      (progress, cacheKey, success, totalLoaded, totalFiles) {    this.progress.text = progress+"%";
//      };


    /**
     * when the load has completed, let's get started
     */
    function onLoadComplete ()
    {
        //  hide the preloader

        $('.preloader').hide();

        //  show the main menu

        showPrimaryScreen('main-menu');

        //  clear the progres timeout

        clearInterval(progressTimer);

        ////show percentage    t
        //
        //this.progress = this.game.add.text(this.game.world.centerX, this.game.world.centerY-30, '0%', {fill: 'white'});
        //
        //this.progress.anchor.setTo(.5,.5);
        ////show progress bar
        ////
        //var progressBar = this.game.add.sprite(this.game.world.centerX, this.game.world.centerY, 'progressBar');
        //
        //progressBar.anchor.setTo(0.5, 0.5);
        //
        //this.game.load.setPreloadSprite(progressBar);
        //
        //this.game.load.onFileComplete.add(this.fileComplete, this);    };

    //PreloadScene.prototype.fileComplete = function
    //(progress, cacheKey, success, totalLoaded, totalFiles) {    this.progress.text = progress+"%";
    }



// WEBPACK FOOTER //
// ./src/ts/game/preload/Preload.ts